import * as React from "react";
const SvgFiRrAgeRestrictionSixteen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-age-restriction-sixteen_svg__a)">
      <path
        fill="#062147"
        d="M13.5 17.25c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5a3.5 3.5 0 0 0-1.484.342A1.996 1.996 0 0 1 14 8.75h1a1 1 0 1 0 0-2h-1c-2.206 0-4 1.794-4 4v3c0 1.93 1.57 3.5 3.5 3.5m0-5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5M24 12a1 1 0 0 1-1 1h-1v1a1 1 0 1 1-2 0v-1h-1a1 1 0 1 1 0-2h1v-1a1 1 0 1 1 2 0v1h1a1 1 0 0 1 1 1M7 16v-5.901l-.523.575a1 1 0 0 1-1.478-1.348l1.732-1.901a1.3 1.3 0 0 1 1.439-.334c.504.197.83.674.83 1.216V16a1 1 0 1 1-2 0m15.059 2.546A11.97 11.97 0 0 1 12 24C5.383 24 0 18.617 0 12S5.383 0 12 0c4.072 0 7.832 2.039 10.059 5.454a1 1 0 1 1-1.676 1.092A9.97 9.97 0 0 0 12 2C6.486 2 2 6.486 2 12s4.486 10 10 10a9.98 9.98 0 0 0 8.383-4.546 1.001 1.001 0 0 1 1.676 1.092"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-age-restriction-sixteen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAgeRestrictionSixteen;
